import { IRequisitionState } from '@/store/requisition';
import { IRequisitionMutations } from './mutations.types';
import {
  IUserData,
  IRequisitionData,
  IRequisitionCommentData,
  IRequisitionLineData
} from '@/models';
import { Transition } from '@/models/transition';

export const mutations: IRequisitionMutations = {
  SET_COUNT(state: IRequisitionState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IRequisitionState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IRequisitionState): void {
    state.count -= 1;
  },

  SET_REQUISITIONS(
    state: IRequisitionState,
    payload: IRequisitionData[]
  ): void {
    state.requisitions = payload;
  },

  ADD_REQUISITION(state: IRequisitionState, payload: IRequisitionData): void {
    state.requisitions.unshift(payload);
  },

  UPDATE_REQUISITION(
    state: IRequisitionState,
    payload: IRequisitionData
  ): void {
    const index = state.requisitions.findIndex(
      (requisition: IRequisitionData) => requisition.id === payload.id
    );

    state.requisitions.splice(index, 1, payload);
  },

  REMOVE_REQUISITION(state: IRequisitionState, payload: number): void {
    const index = state.requisitions.findIndex(
      (requisition: IRequisitionData) => requisition.id === payload
    );

    state.requisitions.splice(index, 1);
  },

  UPDATE_REQUISITION_LINE(
    state: IRequisitionState,
    payload: { id: number; line: IRequisitionLineData }
  ): void {
    const requisitionIndex = state.requisitions.findIndex(
      (requisition: IRequisitionData) => requisition.id === payload.id
    );

    const requisition = state.requisitions[requisitionIndex];

    const requisitionLineIndex = requisition.lines!.findIndex(
      line => line.id === payload.line.id
    );

    requisition.lines!.splice(requisitionLineIndex, 1, payload.line);
  },

  SET_LAST_CREATED_REQUISITION_ID(
    state: IRequisitionState,
    payload: number
  ): void {
    state.lastCreatedRequisitionId = payload;
  },

  SET_LAST_CREATED_REQUISITION_COMMENT_ID(
    state: IRequisitionState,
    payload: number
  ): void {
    state.lastCreatedRequisitionCommentId = payload;
  },

  SET_REQUISITION_APPROVERS(
    state: IRequisitionState,
    payload: IUserData[]
  ): void {
    state.approvers = payload;
  },

  SET_REQUISITION_BUYERS(state: IRequisitionState, payload: IUserData[]): void {
    state.buyers = payload;
  },

  SET_REQUISITION_ACTIVITIES(
    state: IRequisitionState,
    payload: Transition[]
  ): void {
    state.activities = payload;
  },

  SET_REQUISITION_COMMENTS(
    state: IRequisitionState,
    payload: IRequisitionCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_REQUISITION_COMMENT(
    state: IRequisitionState,
    payload: IRequisitionCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_REQUISITION_COMMENT(
    state: IRequisitionState,
    payload: IRequisitionCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IRequisitionCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_REQUISITION_COMMENT(state: IRequisitionState, payload: number): void {
    const index = state.comments.findIndex(
      (comment: IRequisitionCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_MENTIONABLE_USERS(state: IRequisitionState, payload: IUserData[]): void {
    state.mentionableUsers = payload;
  },

  SET_LAST_PROMISE(state: IRequisitionState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
